import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center bg-navy text-slate-300">Loading…</div>;
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
